<template>
  <div class="clearfix w980">
    <div class="v100 weizhi fs12">首页 - 产品 - 刷机大师(PC)</div>
    <product-menu now="romasterlab" />
    <!-- <%Html.RenderPartial("~/Views/HomeV5/_product_menu.ascx", ViewData["product"].ToString());%> -->
    <div class="v100 bigimg mt20">
      <img alt="刷机大师" src="@/assets/images/P1.jpg" />
      <div class="brand">
        <img src="@/assets/images/sjds.jpg" alt="刷机大师" height="75" width="121" />
      </div>
      <h1 style="display: block; position: absolute; left: -5999px">刷机大师(PC)</h1>

      <!-- <%Html.RenderPartial("~/Views/HomeV5/_product_down.ascx", ViewData["product"].ToString());  %> -->
    </div>
    <!-- <div class="v100 meu hover">
      <span class="fl FFF">
        <a href="javascript:;" title="功能介绍">功能介绍</a>
      </span>
      <span class="fr">
        <a href="/updatelog/product" title="更新日志">更新日志</a>
      </span>
    </div> -->
    <div class="v100 gongneng">
      <dl>
        <img alt="刷机大师，提供简单、安全、快速、高效的一键刷机体验" class="fl" src="@/assets/images/Ray1.jpg" />
        <dt class="fr">一键刷机</dt>
        <dd
          class="fr"
        >刷机大师全力为广大安卓用户提供简单、安全、快速、高效的一键刷机体验，只需选择ROM，点击下一步，即可完成刷机。无论您是新手小白还是刷机达人，都可使用刷机大师轻松搞定安卓手机刷机</dd>
      </dl>
      <dl>
        <img alt="刷机大师，内置支持机型超多成功率超高的一键ROOT工具" class="fr" src="@/assets/images/Ray2.jpg" />
        <dt class="fl">一键ROOT</dt>
        <dd class="fl">大师在手，ROOT您有！内置ROOT大师，支持机型超多、成功率超高的ROOT工具，轻松解放您的手机</dd>
      </dl>
      <dl>
        <img alt="刷机大师，内置国内较大的ROM下载平台" class="fl" src="@/assets/images/Ray3.jpg" />
        <dt class="fr">海量ROM</dt>
        <dd class="fr">刷机大师集成ROM基地平台，致力于提供更多更好的ROM资源：强大的ROM团队合作专区，完善的机型分类快速检索，专业的编辑亲测推荐，让您享受个性化的优质服务</dd>
      </dl>
      <dl>
        <img alt="刷机大师，云端不断更新机型支持" class="fr" src="@/assets/images/Ray4.jpg" />
        <dt class="fl">云端服务</dt>
        <dd class="fl">智能化识别您的安卓设备，提供全程云端服务：云端适配、云端检测、云端备份、云端存储等。全方位的安全保障，让您刷机更无忧</dd>
      </dl>
      <dl>
        <img alt="刷机大师，集成应用管理安装卸载预置" class="fl" src="@/assets/images/Ray5.jpg" />
        <dt class="fr">全方位管理</dt>
        <dd class="fr">刷机大师集应用下载、安装、升级、备份、卸载为一体，更有自动安装、清除缓存、批量管理等一键式服务，为您提供更为人性化的安卓手机管理体验</dd>
      </dl>
    </div>
  </div>
</template>
<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "Romasterlab",
  components: {
    ProductMenu
  }
};
</script>


// WEBPACK FOOTER //
// src/components/function/romasterlab.vue